import React, { useEffect, useState } from "react";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";
import Form from "react-bootstrap/Form";

const HowItWorks = ({ cmsLits }) => {

  const [value1, setValue1] = useState()
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'How It Works')))
    }
  }, [cmsLits]);


  const toggleChecked = (e) => {
    setChecked((value) => !value);
  };


  return (
    <div className="how_it_works">
      <Container className="custom_container">
        <div className="header_sec">
          <Row className="mt-0">
            <Col xs={12} md={12} lg={11}>
              <p className="title-txt">
                {value1?.heading}
              </p>
              <p className="paracontent t-grey mb-0">
                {value1?.content}

              </p>
            </Col>
          </Row>

          <div className="manual_auto_toggleSec">
            <span>Manual</span>
            <Form.Check
              type="switch"
              checked={checked}
              className="manual_auto_toggle"
              onChange={toggleChecked}
            />
            <span>Automatic</span>
          </div>
        </div>

        {/* {checked ? (
          <>
            <div className="works_steps">
              <div className="cmn_step step1">
                <div className="item">
                  <img src={Images.atStep1} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">Connect Wallet</p>
                </div>
              </div>
              <div className="cmn_step step2">
                <div className="item">
                  <img src={Images.atStep2} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Subscribe Bot <span className="new_line">Package </span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step3">
                <div className="item">
                  <img src={Images.atStep3} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Add Funds in Vault{" "}
                    <span className="new_line">(for Gas Fee)</span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step4">
                <div className="item">
                  <img src={Images.atStep4} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Adjust Gas Fee,
                    <span className="new_line">Pairs Exchanges</span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step5">
                <div className="item">
                  <img src={Images.atStep5} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">Start the Bot</p>
                </div>
              </div>
              <div className="cmn_step step6">
                <div className="item">
                  <img src={Images.atStep6} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Profit Will be in{" "}
                    <span className="new_line">your Wallet</span>
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="works_steps">
              <div className="cmn_step step1">
                <div className="item">
                  <img src={Images.mnStep1} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">Connect Wallet</p>
                </div>
              </div>
              <div className="cmn_step step2">
                <div className="item">
                  <img src={Images.mnStep2} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Subscribe Bot <span className="new_line">Package </span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step3">
                <div className="item">
                  <img src={Images.mnStep3} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Select any pairs or{" "}
                    <span className="new_line">opportunities in market</span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step4">
                <div className="item">
                  <img src={Images.mnStep4} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Confirm the
                    <span className="new_line">Transaction</span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step5 manual">
                <div className="item">
                  <img src={Images.mnStep5} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Trade now /
                    <span className="new_line">Schedule trade at any time</span>
                    <span className="new_line">any time </span>
                  </p>
                </div>
              </div>
              <div className="cmn_step step6">
                <div className="item">
                  <img src={Images.mnStep6} className="img-src img-fluid" />
                  <p className="step-txt mb-0">step</p>
                  <p className="value mb-0">
                    Profit Will be in{" "}
                    <span className="new_line">your Wallet</span>
                  </p>
                </div>
              </div>
            </div>
          </>
        )} */}
      </Container>
      <div className="works_steps">
        <p className="centertext hacked-font">sector-8</p>
        <img src={Images.howitworkbg} alt="How it works" className="img-fluid works_stepsbg" />
        <div className="cmn_step step1">
          <div className="item">
            <img src={Images.atStep1} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 1</p>
            <p className="value mb-0">Connect Wallet</p>
          </div>
        </div>
        <div className="cmn_step step2">
          <div className="item">
            <img src={Images.atStep2} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 2</p>
            <p className="value mb-0">
              Subscribe Bot <span className="new_line">Package </span>
            </p>
          </div>
        </div>
        <div className="cmn_step step3">
          <div className="item">
            <img src={checked ? Images.atStep3 : Images.atSteptwo3} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 3</p>
            <p className="value mb-0">
              {checked ? <span>Add Funds in Vault (for Gas Fee)</span> : <span>Select any pairs or opportunities in market</span>}
            </p>
          </div>
        </div>
        <div className="cmn_step step4">
          <div className="item">
            <img src={checked ? Images.atStep4 : Images.atSteptwo4} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 4</p>
            <p className="value mb-0">
              {checked ? <span>Adjust Gas Fee, Pairs Exchanges</span> : <span>Confirm the Transaction</span>}
            </p>
          </div>
        </div>
        <div className="cmn_step step5">
          <div className="item">
            <img src={checked ? Images.atStep5 : Images.atSteptwo5} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 5</p>
            <p className="value mb-0">
              {checked ? <span>Start the Bot</span> : <span>Trade now / Schedule trade at any time</span>}
            </p>
          </div>
        </div>
        <div className="cmn_step step6">
          <div className="item">
            <img src={Images.atStep6} className="img-src img-fluid" />
            <p className="step-txt mb-0">step 6</p>
            <p className="value mb-0">
              Profit Will be in{" "}
              <span className="new_line">your Wallet</span>
            </p>
          </div>
        </div>
      </div>
      {
        !checked &&
        <div className="works_stepstext">
          <p className="paracontent">
            <span>Important notes*</span>  User must have matic in their wallet for gas fee
          </p>
        </div>
      }
    </div>
  );
};

export default HowItWorks;
